import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=f742e962&scoped=true&"
import script from "./OverviewTab.vue?vue&type=script&lang=js&"
export * from "./OverviewTab.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&id=f742e962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f742e962",
  null
  
)

export default component.exports